<template>
  <v-row style="border-bottom: 1px solid #dfdfdf" no-gutters>
    <v-col
      style="border-right: 1px solid #dfdfdf"
      :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
    >
      <Position />
    </v-col>
    <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
      <Information />
    </v-col>
  </v-row>
</template>

<script>
import Position from "./Position.vue";
import Information from "./Information.vue";
export default { components: { Position, Information } };
</script>

<style></style>
